import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App'; // Old BeautyPlease/StylistNotebook app
import PlantADayApp from './PlantADayApp'; // New PlantADay app
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode disabled to prevent double-mounting which was causing issues
  <PlantADayApp />
);

// Register the service worker in production so the app is installable and
// resilient to flaky connections. In dev it's a no-op (and any prior worker
// is unregistered to avoid stale bundles).
serviceWorkerRegistration.register();